import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../model';

@Component({
    selector: 'user-balloon',
    template: '<div class="user-balloon" [matTooltip]="tooltip | localize">{{initials}}</div>',
    styles: [`
        .user-balloon {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #F5F5F5;
            color: #212121;
            width: 32px;
            height: 32px;
            padding: 4px;
            border-radius: 24px;
            font-weight: 600;
            font-size: 12px;
        }
    `]
})
export class UserBalloonComponent implements OnInit {

    @Input() user: User;

    initials: string;
    tooltip: string;

    ngOnInit(): void {
        if (this.user) {
            const fullNameArray = [this.user.firstName, this.user.lastName].filter(n => n);
            if (fullNameArray.length) {
                this.initials = fullNameArray.map(n => n[0]).join('').toUpperCase();
                this.tooltip = fullNameArray.join(' ');
            } else {
                this.initials = this.user.email[0];
                this.tooltip = this.user.email;
            }
        } else {
            this.initials = '-';
            this.tooltip = 'No longer existing user';
        }
    }

}